<div tabindex="0" class="me-dashboard--col me-banners--card bg-secondary" *ngIf="data">
    <h2 class="me-banners--card__header lg">
        {{data.title}}
    </h2>
    <ng-container *ngIf="srStep === 0">
        <p class="">
            {{data.evaluatingText}}
        </p>
        <div class="me-dashboard--col--btn">
            <button class="btn btn--primary w-100" (click)="goToSR()">
                {{data.startButtonText}}
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="srStep > 0">
        <p class="">
            {{data.continuingText}}
        </p>
        <div class="me-dashboard--col--btn">
            <button class="btn btn--primary w-100" (click)="goToSR()">
                {{data.continueButtonText}}
            </button>
        </div>
    </ng-container>
</div>